import { Injectable, inject } from "@angular/core";
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from "@angular/material/snack-bar";

@Injectable({
	providedIn: "root",
})
export class AlertService {
	private _snackBar = inject(MatSnackBar);

	public openSnackBar(
		message: string,
		actionText: string = '',
		duration: number = 0,
	): MatSnackBarRef<SimpleSnackBar> {
		if (!actionText) actionText = "DISMISS";
		if (duration <= 0) duration = 3000;

		return this._snackBar.open(message, actionText, {
			duration: duration,
			horizontalPosition: "center"
		});
	}

	public dismissVisibleSnackBar(): void {
		this._snackBar.dismiss();
	}
}
